import React from 'react';
import ResultCount from 'components/form-wizards/click-portal-search/ResultCount';
import ToolTip from 'components/base/toolTip/ToolTip';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import { CLICK_PORTAL_CARD_LAYOUT } from 'consts';
import { GetSchoolListingResults } from 'types';

import ResultCard from './result-card/ResultCard';

interface LoadingData {
  id: string;
}
interface ClickPortalResultsSectionProps {
  results: GetSchoolListingResults['results'] | LoadingData[];
  resultType?: 'matches' | 'nonMatches';
  disclosure?: string;
  isLoading?: boolean;
  title?: string;
  cardLayout?: CLICK_PORTAL_CARD_LAYOUT;
}

function ClickPortalResultsSection({
  results,
  resultType = 'matches',
  disclosure,
  isLoading,
  title,
  cardLayout,
}: ClickPortalResultsSectionProps): React.JSX.Element {
  function getBadge(index: number): string {
    return resultType === 'matches' && index === 0 ? "Editor's Choice" : '';
  }

  return (
    <div
      className={`clickPortalResults__section clickPortalResults__section--${resultType}`}
    >
      {title && (
        <h4
          className="clickPortalResults__sectionTitle"
          data-testid={`clickPortalResults__sectionTitle--${resultType}`}
        >
          {title}
        </h4>
      )}
      <div className="clickPortalResults__meta">
        <div
          className="clickPortalResults__count"
          data-testid={`clickPortalResults__count--${resultType}`}
        >
          <ResultCount count={results?.length} />
        </div>
        {disclosure && (
          <div className="clickPortalResults__disclosure">
            <ToolTip label="Advertiser Disclosure" positioning="bottom">
              <Wysiwyg isClean content={disclosure} />
            </ToolTip>
          </div>
        )}
      </div>

      <ul
        className={`clickPortalResults clickPortalResults--${resultType}`}
        data-testid={`clickPortalResults--${resultType}`}
      >
        {results.map((school, index) => {
          return (
            <li
              className="clickPortalResults__item"
              key={`${school.id}_${
                'impressionGuid' in school ? school.impressionGuid : index
              }`}
            >
              <ResultCard
                isLoading={isLoading}
                schoolInfo={school}
                index={index}
                badge={getBadge(index)}
                cardLayout={cardLayout}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ClickPortalResultsSection;
